export const levelTinhUnit = { label: "Tỉnh/ Thành", value: "T" };
export const levelHuyenUnit = { label: "Quận/ Huyện", value: "H" };
export const levelXaUnit = { label: "Phường/ Xã", value: "X" };
export const levelTrungUongUnit = { label: "Trung ương", value: "W" };
export const levelUnits = [levelTinhUnit, levelHuyenUnit, levelXaUnit, levelTrungUongUnit];

export const parseLevelUnit = (value) => {
    if (value) {
        return levelUnits.find((e) => e.value === value)?.label;
    }
    return "";
};
